import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'

/**
 * A deliberately plain page for surfaces that exist structurally but have no
 * design yet. Kept bare so it is never mistaken for a finished screen.
 */
export default function StubPage({
  eyebrow,
  title,
  children,
}: {
  eyebrow: string
  title: string
  children?: ReactNode
}) {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        padding: 'var(--space-4)',
      }}
    >
      <div style={{ maxWidth: 'var(--measure)', width: '100%' }}>
        <p className="meta" style={{ letterSpacing: '0.3em' }}>
          {eyebrow}
        </p>
        <h1
          style={{
            fontSize: 'var(--text-xl)',
            letterSpacing: '0.12em',
            color: 'var(--ink-bright)',
            margin: 'var(--space-3) 0 var(--space-4)',
          }}
        >
          {title}
        </h1>
        {children}
        <p style={{ marginTop: 'var(--space-5)' }}>
          <Link to="/" style={{ color: 'var(--warm)', letterSpacing: '0.2em' }}>
            ‹ BACK
          </Link>
        </p>
      </div>
    </div>
  )
}
